import React, { useState } from "react";
import "./Home.css";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import Product from "./Product";

const slides = [
  { url: "https://m.media-amazon.com/images/I/61lwJy4B8PL._SX3000_.jpg" },
  { url: "https://m.media-amazon.com/images/I/71Ie3JXGfVL._SX3000_.jpg" },
  { url: "https://m.media-amazon.com/images/I/71U-Q+N7PXL._SX3000_.jpg" },
  { url: "https://m.media-amazon.com/images/I/81KkrQWEHIL._SX3000_.jpg" },
  { url: "https://m.media-amazon.com/images/I/61zAjw4bqPL._SX3000_.jpg" },
];

function Home() {
  const slidesSize = slides.length;
  const [index, setActiveStep] = useState(0);

  const goToNextPicture = () => {
    setActiveStep(index === slidesSize - 1 ? 0 : index + 1);
  };

  const gotToPreviousPicture = () => {
    setActiveStep(index === 0 ? slidesSize - 1 : index - 1);
  };

  return (
    <div className="home">
      <div className="home__container">
        <ArrowBackIos className="backward" onClick={gotToPreviousPicture} />
        <ArrowForwardIos className="forward" onClick={goToNextPicture} />
        <img className="home__image" src={slides[index].url} />

        <div className="home__row">
          <Product
            id="1339016575"
            title="The Ballad of Songbirds and Snakes (A Hunger Games Novel) (The Hunger
          Games) Paperback - August"
            price={12.74}
            image="https://m.media-amazon.com/images/I/51f4AsSs74L._AC_SY200_.jpg"
            rating={5}
          />
          <Product
            id="B09MGDQV3B"
            title="Jenga Official Giant JS4 - Oversized Stacks to Over 3 Feet in Play, Includes Heavy-Duty Carry Bag, Premium Splinter Resistant Hardwood Blocks, Precision-Crafted Trusted Brand Game "
            price={75}
            rating={3}
            image="https://m.media-amazon.com/images/I/41lyAYOb+vL._AC_SY200_.jpg"
          />
        </div>
        <div className="home__row">
          <Product
            id="B00G38HFL0"
            title="Shepherd's Hooks Garden Stakes Set "
            price={14.22}
            rating={3}
            image="https://m.media-amazon.com/images/I/31tmnCWw3RL._AC_SY200_.jpg"
          />
          <Product
            id="B00FMHPY66"
            title="DEWALT Oscillating Tool Blades Set, 3-Piece (DWA4215) "
            price={19.66}
            rating={4}
            image="https://m.media-amazon.com/images/I/41p6b08eFDL._AC_SY200_.jpg"
          />
          <Product
            id="B0B4SZT6X1"
            title="VEVOR 110V Mash Boil Device All-in-One Brewing System, Φ14x24.2 in, Silver "
            price={294.99}
            rating={3}
            image="https://m.media-amazon.com/images/I/4173Z0SknuL._AC_SY200_.jpg"
          />
        </div>
        <div className="home__row">
          <Product
            id="B00DDOW9CC"
            title="Nip + Fab Glycolic Acid Fix Face Scrub with Salicylic Acid, AHA/BHA Exfoliating Facial Cleanser Polish"
            price={9.95}
            rating={4}
            image="https://m.media-amazon.com/images/I/31mH6dhEMJL._AC_SY200_.jpg"
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
